(function() {
    'use strict';

    angular.module('app.variables', []);
})();
